import { defineMeta } from '@/registry/types';

export const paginationMeta = defineMeta({
  name: 'Pagination',
  level: 'molecule',
  category: 'navigation',
  classification: 'themed-mui',
  description: 'Page navigation for long lists and tables. Themed MUI Pagination.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Pagination',
  muiDocs: 'https://mui.com/material-ui/react-pagination/',
  a2uiEquivalent: 'Pagination',
  importPath: '@/molecules/Pagination',
  requiredProps: ['count'],
  optionalProps: ['page', 'onChange', 'variant', 'shape', 'color', 'siblingCount'],
  supportedStates: ['default', 'selected', 'disabled'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Renders nav with aria-labels per page; keyboard operable.'],
  usageExamples: ['<Pagination count={10} page={p} onChange={set} />'],
  antiPatterns: ['Do not use for infinite scroll patterns.'],
  llmSafe: true,
  whenToUse: ['Paged tables/lists with known total pages'],
  whenNotToUse: ['Continuous feeds'],
});

export default paginationMeta;
